var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3628 19.5856C11.2095 19.4959 11.1152 19.3316 11.1152 19.154V9.46167C11.1152 9.28404 11.2095 9.11974 11.3628 9.03007C11.5161 8.94039 11.7055 8.9388 11.8604 9.02588L20.4757 13.872C20.6332 13.9606 20.7306 14.1272 20.7306 14.3078C20.7306 14.4885 20.6332 14.6551 20.4757 14.7436L11.8604 19.5898C11.7055 19.6769 11.5161 19.6753 11.3628 19.5856Z",
    fill: "#522D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1725 23.2939C19.2691 24.7502 16.8894 25.6154 14.3077 25.6154C8.06263 25.6154 3 20.5528 3 14.3077C3 8.06263 8.06263 3 14.3077 3C20.5528 3 25.6154 8.06263 25.6154 14.3077C25.6154 16.8894 24.7502 19.2691 23.2939 21.1725L25.2618 23.1404C26.0136 23.0337 26.8047 23.2694 27.383 23.8477L32.7676 29.2323C33.7439 30.2086 33.7439 31.7915 32.7676 32.7679C31.7913 33.7442 30.2084 33.7442 29.2321 32.7679L23.8475 27.3832C23.2691 26.8048 23.0333 26.0135 23.1403 25.2616L21.1725 23.2939ZM23.6154 14.3077C23.6154 19.4482 19.4482 23.6154 14.3077 23.6154C9.1672 23.6154 5 19.4482 5 14.3077C5 9.1672 9.1672 5 14.3077 5C19.4482 5 23.6154 9.1672 23.6154 14.3077Z",
    fill: "#522D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipsIcon);
export default __webpack_public_path__ + "static/media/Clips_icon.a619dd22dda0ee25a0a833e7e6ab1607.svg";
export { ForwardRef as ReactComponent };